import { useSelector } from 'react-redux';
import useUserInfo from '../../hooks/useUserInfo';
import { useRunOnceWhenTruthy } from '../common/useRunOnceWhenTruthy';
import { selectUserInfoData } from '../../reducers/userInfoReducer';
import { AccountType } from '@server/account-type';

export const useExpandedDocumentationForFreeUsers = () => {
  const userInfo = useSelector(selectUserInfoData);
  const { updateCanvasMode } = useUserInfo();

  useRunOnceWhenTruthy(() => {
    if (
      !userInfo?.preferences?.hasOwnProperty('canvasPanelModeExpanded') &&
      userInfo?.account?.type === AccountType.Free
    ) {
      updateCanvasMode(true);
    }
  }, !!userInfo);
};
